/* START OF COMPILED CODE */
import { MenuSlider } from '../components/ui/MenuSlider';
import { NotchedMenuSlider } from '../components/ui/NotchedMenuSlider';
import { MenuCheckbox } from '../components/ui/MenuCheckbox';
import { StyledButton } from '../components/ui/StyledButton';

export default class MenuScene extends Phaser.Scene {
    constructor() {
        super({ key: 'MenuScene' });
        this.menuType = null;
    }
    /* START-USER-CODE */


    init(data) {
        this.menuType = data.menuType;
    }

    preload() {
        this.load.image('menuBG', '/sprites/ui/Menu/MenuBG_Pink.png');
        this.load.image('closeButton', '/sprites/ui/Menu/closeButton.png');
        this.load.image('panelTest', '/sprites/ui/inventory/panelTest.png')
    }

    create() {
        this.game.events.on('forceCloseMenus', () => {
            this.scene.sleep();
        });
        
        this.scene.bringToTop();
        this.cameras.main.setViewport(0, 0, 256, 192);

        const PLAY_AREA_WIDTH = 256;
        const PLAY_AREA_HEIGHT = 192;
        const PADDING = 16;
        const menuWidth = PLAY_AREA_WIDTH - (PADDING * 2);
        const menuHeight = PLAY_AREA_HEIGHT - (PADDING * 2);
        const menuCenterX = this.cameras.main.width / 2;
        const menuCenterY = this.cameras.main.height / 2;
        
        const menu = this.add.nineslice(
            menuCenterX,
            menuCenterY,
            'menuBG',       
            null,           
            menuWidth,      
            menuHeight,     
            24,            
            24,            
            24,            
            24             
        ).setOrigin(0.5);

        // Add close button in top right
        const closeButton = this.add.image(
            PADDING + menuWidth - 10,
            PADDING + 10,
            'closeButton'
        )
        .setScale(1)
        .setInteractive();

        closeButton.on('pointerup', () => {
            this.scene.sleep();
        });

        // Add menu title
        const titles = {
            inventory: 'Inventory',
            equipment: 'Equipment',
            stats: 'Stats',
            map: 'Map',
            quests: 'Quests',
            leaderboard: 'Leaderboard',
            settings: 'Settings'
        };

        this.add.bitmapText(
            PADDING + 10,
            PADDING + 5,
            'VCROSDMono',
            titles[this.menuType] || '',
            14
        ).setTintFill(0x57534d);

        // Close on outside click
        this.input.on('pointerdown', (pointer) => {
            const bounds = menu.getBounds();
            if (!bounds.contains(pointer.x, pointer.y)) {
                this.scene.sleep();
            }
        });

        /////////////////////////////////////
        ///  CUSTOM SETUP FOR MENU TYPES  ///
        /////////////////////////////////////

        switch (this.menuType) {
            case "settings":
                const volumeSlider = new MenuSlider(
                    this,
                    PADDING + 15,
                    PADDING + 50,
                    {
                        label: 'Volume',
                        initialValue: 75,
                        onChange: (value) => {
                            this.sound.volume = value / 100;
                        }
                    }
                );

                // Add Leave Game button
                const leaveButton = this.add.text(
                    PADDING + menuWidth / 2,
                    PADDING + menuHeight - 30,
                    'Leave Game',
                    {
                        fontSize: '12px',
                        color: '#ffffff',
                        backgroundColor: '#ef4444',
                        padding: { x: 10, y: 5 },
                        align: 'center'
                    }
                )
                .setOrigin(0.5)
                .setInteractive()
                .on('pointerover', function() {
                    this.setStyle({ backgroundColor: '#dc2626' });
                })
                .on('pointerout', function() {
                    this.setStyle({ backgroundColor: '#ef4444' });
                })
                .on('pointerup', () => {
                    // Navigate to root
                    window.location.href = '/';
                });

                break;
            case "inventory":
                this.add.image(128, 96, 'panelTest');
                break;
            case "leaderboard":
                this.setupLeaderboard(PADDING - 4, menuWidth, menuHeight);
                break;
            case "quests":
                const comingSoonQu = this.add.text(
                    PADDING + menuWidth / 2 - 100,
                    PADDING + menuHeight - 30,
                    'Coming soon...',
                    {
                        fontSize: '24px',
                        color: '#ffff99',
                        align: 'left'
                    }
                )
                break;
            case "equipment":
                 const comingSoonEq = this.add.text(
                    PADDING + menuWidth / 2 - 100,
                    PADDING + menuHeight - 30,
                    'Coming soon...',
                    {
                        fontSize: '24px',
                        color: '#ffff99',
                        align: 'left'
                    }
                )
                break;
            case 4:
                day = "Thursday";
                break;
            case 5:
                day = "Friday";
                break;
            case 6:
                day = "Saturday";
        }
    }

    async setupLeaderboard(PADDING, menuWidth, menuHeight) {
        const LeaderboardService = (await import('../services/LeaderboardService')).default;
        const gameStore = this.game.registry.get('gameStore');
        if (!gameStore || !gameStore.walletAddress) {
            console.error('No wallet address found');
            return;
        }
        
        // Loading text
        const loadingText = this.add.text(
            PADDING + menuWidth / 2,
            PADDING + menuHeight / 2,
            'Loading leaderboard...',
            {
                fontSize: '12px',
                color: '#000000',
                align: 'center',
                resolution: 4,  
            }
        ).setOrigin(0.5);

        try {
            // Fetch data
            const { leaderboard } = await LeaderboardService.getTop10();
            const playerRank = gameStore.walletAddress ? await LeaderboardService.getPlayerRank(gameStore.walletAddress) : null;
            //console.log("RANK: " + playerRank.rank);
            // Remove loading text
            loadingText.destroy();

            // Check if player is in top 10
            const playerInTop10 = playerRank.rank && playerRank.rank <= 10;
            
            // Header
            const startY = PADDING + 26;
            const rowHeight = 10;
            const headerY = startY;

            this.add.bitmapText(PADDING + 30, headerY, 'VCROSDMono', 'Name', 12);
            this.add.bitmapText(PADDING + 85, headerY,'VCROSDMono', 'Pet', 12);
            this.add.bitmapText(PADDING + 130, headerY, 'VCROSDMono', 'Wallet', 12);
            this.add.bitmapText(PADDING + 195, headerY,'VCROSDMono', 'Pts', 12);

            const playerColor = "#FFF"
            //console.log(leaderboard);
            // Render top 10
            leaderboard.forEach((entry, index) => {
                const y = startY + rowHeight + (index * rowHeight);
                const isCurrentPlayer = (playerRank.rank == index )

                let rowColor = isCurrentPlayer ? '#11AA' :'#000000'

                this.add.bitmapText(PADDING + 10, y, 'VCROSDMono',  `${entry.rank}`, 11).setTintFill(0x57534d);                
                this.add.bitmapText(PADDING + 30, y, 'VCROSDMono', entry.username || 'Unknown', 11).setTintFill(0x292524);
                this.add.bitmapText(PADDING + 85, y, 'VCROSDMono', entry.pet_name || 'N/A', 11);
                this.add.bitmapText(PADDING + 130, y,'VCROSDMono',  entry.wallet_address, 10);
                this.add.bitmapText(PADDING + 195, y, 'VCROSDMono', `${entry.care_score}`, 11);
            });

               
            // Show player's rank if not in top 10
            if (playerRank && !playerInTop10) {
                const yourRankY = startY + rowHeight + (11 * rowHeight);

                this.add.text(PADDING + 15, yourRankY, 'YOUR RANK', {
                    fontSize: '10px',
                    color: '#000000',
                    fontStyle: 'bold'
                });

                const playerY = yourRankY + rowHeight;

                this.add.rectangle(
                    PADDING + menuWidth / 2,
                    playerY,
                    menuWidth - 20,
                    rowHeight - 2,
                    0x4caf50,
                    0.3
                );

                this.add.text(PADDING + 15, playerY, `${playerRank.rank}`, { fontSize: '9px', color: '#FFF' });
                this.add.text(PADDING + 30, playerY, playerRank.username || 'Unknown', { fontSize: '9px', color: '#FFF' });
                this.add.text(PADDING + 85, playerY, playerRank.pet_name || 'N/A', { fontSize: '9px', color: '#FFF' });
                this.add.text(PADDING + 130, playerY, playerRank.wallet_address, { fontSize: '9px', color: '#666666' });
                this.add.text(PADDING + 190, playerY, `${playerRank.care_score}`, { fontSize: '9px', color: '#FFF' });
            }

        } catch (error) {
            loadingText.setText('Failed to load leaderboard');
            console.error('Error loading leaderboard:', error);
        }
    }

    shutdown() {
        this.game.events.off('forceCloseMenus');
    }
/* END-USER-CODE */
}
/* END OF COMPILED CODE */
